import { plainToClass } from 'class-transformer';
import {
  API_STATE_FIND_ALL,
  API_STATE_FIND_ONE,
  API_STATE_CREATE,
  API_STATE_UPDATE,
  API_STATE_DELETE
} from '../api.routes';
import { BaseApi } from './base.api';
import { StateDto } from '../dto';
import { FindAllResponse } from '../types';

export class StateApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<StateDto>> {
    return this.httpClient
      .get(API_STATE_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(StateDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<StateDto> {
    return this.httpClient
      .get(API_STATE_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(StateDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<StateDto> {
    return this.httpClient.post(API_STATE_CREATE, data).then(({ data }) => {
      return plainToClass(StateDto, data);
    });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<StateDto> {
    return this.httpClient.put(API_STATE_UPDATE, data).then(({ data }) => {
      return plainToClass(StateDto, data);
    });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_STATE_DELETE, {
      pathParams: { uuid }
    });
  }
}
